import { useMutation } from '@tanstack/react-query';
import axiosInstance from '../../../utils/axios';

const downloadUserExport = async (userId: string) => {
  const response = await axiosInstance.get(`/users/export/${userId}`, {
    responseType: 'blob',
  });
  console.log(response);
  let filename = 'users_export.zip';
  const disposition = response.headers['content-disposition'];
  console.log(disposition);
  if (disposition) {
    const match = disposition.match(/filename="(.+?)"/);
    if (match && match[1]) filename = match[1];
  }
  // Return both blob and filename for use in onSuccess
  return { blob: response.data, filename };
};

const useUserExportDownload = () => {
  return useMutation({
    mutationFn: downloadUserExport,
    onSuccess: ({ blob, filename }) => {
      const url = window.URL.createObjectURL(new Blob([blob]));
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    },
    onError: (err) => {
      alert('Failed to download export data');
      console.error(err);
    },
  });
};

export default useUserExportDownload;
